import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MAIN_NAV_ITEMS } from '@/config/navigation';
import { BrandLogo } from '@/components/BrandLogo';

export function TopNavigation() {
  const location = useLocation();
  const { t } = useTranslation();
  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="hidden md:block w-full border-b border-border bg-card/50 backdrop-blur-sm sticky top-0 z-40">
      <div className="flex items-center justify-between h-14 px-4">
        <Link to="/profile" className="flex items-center gap-2">
          <BrandLogo size={36} className="" />
          <span className="text-lg font-semibold hidden sm:inline">BlissNet</span>
        </Link>

        <div className="flex items-center gap-1">
          {MAIN_NAV_ITEMS.map(({ path, labelKey, icon: Icon }) => (
            <Link
              key={path}
              to={path}
              className={`
                flex items-center gap-2 px-3 py-2 rounded-lg
                transition-colors duration-200
                ${isActive(path)
                  ? 'bg-primary/10 text-primary'
                  : 'text-muted-foreground hover:text-foreground hover:bg-accent/10'
                }
              `}
            >
              <Icon className="w-5 h-5" />
              <span className="text-sm font-medium hidden lg:inline">{t(labelKey)}</span>
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}


